import { parsedContent } from '@/lib/utils'
import boxLeft from '~/public/images/box-storage/left.png'
import boxRight from '~/public/images/box-storage/right.png'
import golfLeft from '~/public/images/golf-club-storage/left.png'
import golfRight from '~/public/images/golf-club-storage/right.png'
import luggageLeft from '~/public/images/luggage-storage/left.png'
import luggageRight from '~/public/images/luggage-storage/right.png'
import skiLeft from '~/public/images/ski-storage/left.png'
import skiRight from '~/public/images/ski-storage/right.png'
import snowLeft from '~/public/images/snowboard-storage/left.png'
import snowRight from '~/public/images/snowboard-storage/right.png'

import luggageBoxStorageLeft from '~/public/images/location-box-storage/banner-image-left.png'
import luggageBoxStorageRight from '~/public/images/location-box-storage/banner-image-right.png'

export const BANNERS = Object.freeze({
  boxStorage: {
    title: parsedContent(`Box Storage Near You`),
    description: parsedContent(
      `Store even if you have just a single piece of Box! We are not your typical Box storage service. With our innovative smart Box storage solution, you won't have to rent any unnecessary space.`,
      'max-w-[1024px] mx-auto'
    ),
    leftImage: { src: boxLeft, wrClassName: 'w-[459px] h-[229px]' },
    rightImage: { src: boxRight, wrClassName: 'w-[330px] h-[247px]' },
    desktopContentWrClassName: 'pt-[54px] pb-[100px]'
  },
  golfClub: {
    title: parsedContent(`Golf Club Storage Near You`),
    description: parsedContent(
      `Store even if you have just a single piece of Golf club! We are not your typical Golf club storage service. With our innovative smart Golf club storage solution, you won't have to rent any unnecessary space.`,
      'lg-mn:max-w-[1000px] lg-mn:mx-auto'
    ),
    leftImage: { src: golfLeft, wrClassName: 'w-[546px] h-[191px]' },
    rightImage: { src: golfRight, wrClassName: 'w-[269px] h-[231px]' },
    desktopContentWrClassName: 'pt-[54px] pb-[100px]',
    callToAction: { available: true }
  },
  luggageStorage: {
    title: parsedContent(`Luggage Storage Near You`),
    description: parsedContent(
      `Store even if you have just a single piece of luggage! We are not your typical luggage storage service. With our innovative smart luggage storage solution, you won't have to rent any unnecessary space.`,
      ''
    ),
    leftImage: { src: luggageLeft, wrClassName: 'w-[411px] h-[165px]' },
    rightImage: { src: luggageRight, wrClassName: 'w-[284px] h-[149px]' },
    desktopContentWrClassName: 'pt-[54px] pb-[100px]',
    callToAction: { available: true }
  },
  skiStorage: {
    title: parsedContent(`Ski Storage Near You: Your Convenient Solution`, 'max-w-[800px] mx-auto'),
    description: parsedContent(
      `Store even if you have just a single piece of Ski! We are not your typical Ski storage service. With our innovative smart Ski storage solution, you won't have to rent any unnecessary space.`
    ),
    leftImage: { src: skiLeft, wrClassName: 'w-[365px] h-[235px]' },
    rightImage: { src: skiRight, wrClassName: 'w-[303px] h-[285px]' },
    desktopContentWrClassName: 'pt-[54px] pb-[100px]',
    callToAction: { available: true }
  },
  snowboardStorage: {
    title: parsedContent(`Secure and Convenient Snowboard Storage Options Near You!`, 'max-w-full mx-auto'),
    description: parsedContent(
      `Store even if you have just a single piece of snowboard! We are not your typical snowboard storage service. With our innovative smart Snowboard storage solution, you won't have to rent any unnecessary space.`
    ),
    leftImage: { src: snowLeft, wrClassName: 'w-[546px] h-[199px]' },
    rightImage: { src: snowRight, wrClassName: 'w-[160px] h-[203px]' },
    desktopContentWrClassName: 'pt-[54px] pb-[100px]',
    callToAction: { available: true }
  },
  luggageBoxShippingServices: {
    title: parsedContent(`How Luggage & Box Shipping Works`, 'max-w-full mx-auto'),
    description: parsedContent(
      `
      Have you moved to another city or country? No problem, we can ship anytime, anywhere!
      <br/> You don't have to come back to our warehouse!
      `
    ),
    leftImage: { src: luggageBoxStorageLeft, wrClassName: 'w-[371px] h-[260px]' },
    rightImage: { src: luggageBoxStorageRight, wrClassName: 'w-[418px] h-[304px]' },
    desktopContentWrClassName: 'pt-[54px] pb-[100px]',
    callToAction: { available: true }
  }
})
